import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Spanish Conversation Cards Pack',
  value: '27',
  desc: 'Conversation cards ready to use — designed to generate real oral participation, pair work, group discussion, and genuine confidence in speaking Spanish. Every card is a real communicative prompt — not a fill-in-the-blank grammar exercise. Students actually have something to say. And they actually say it.',
  benefit: 'Never again sit through painful silence during speaking activities.'
}, {
  id: '02',
  title: 'No-Prep Spanish Activities Pack',
  value: '27',
  desc: 'Fast, practical activities you can use with zero preparation — perfect for reviews, last-minute lessons, early finishers, and any moment when you need something that works immediately. Open it. Run it. Done.',
  benefit: 'Never again improvise desperately when a lesson runs short or a plan falls apart.'
}, {
  id: '03',
  title: "Spanish Teacher's Emergency Vault",
  value: '37',
  desc: 'Lessons and resources for schedule changes, technology failures, unexpected absences, unplanned classes, and every situation where you need an immediate solution. This is the professional insurance policy every Spanish teacher needs — and almost none have.',
  benefit: 'Never again face a classroom emergency without a complete, ready-to-run solution.'
}, {
  id: '04',
  title: 'Hispanic Culture Classroom Pack',
  value: '27',
  desc: 'Cultural readings, activities, and projects that bring the real diversity of the Spanish-speaking world into your classroom — moving far beyond surface-level stereotypes toward authentic, contemporary cultural content. Your heritage speakers will feel represented. Your non-heritage students will discover a world they did not know existed.',
  benefit: 'Never again reduce 500 million people to a piñata and a sombrero.'
}, {
  id: '05',
  title: 'Spanish Assessments and Rubrics Pack',
  value: '37',
  desc: 'Assessments, rubrics, self-assessment tools, tracking instruments, and resources to measure student progress clearly, consistently, and without consuming your entire weekend. Every assessment is designed to measure real communication — not grammar rule recall.',
  benefit: 'Never again build an exam from scratch under pressure on a Thursday night.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-navy border-y border-navy-light" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-turquoise font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Included at No Extra Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white" data-id="element-19">
            🎁 The 5 Exclusive Bonus Packs
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-navy-dark border border-turquoise/20 rounded-2xl p-8 relative group hover:border-turquoise/50 transition-colors ${index === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-21">
              <div className="absolute top-0 right-0 bg-turquoise/10 text-turquoise px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-turquoise/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-turquoise/20 rounded-full flex items-center justify-center text-turquoise mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16 text-white" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-white/60 text-sm" data-id="element-27">
                  Real value:{' '}
                  <span className="line-through" data-id="element-28">${bonus.value}</span>
                </span>
                <span className="text-turquoise font-bold ml-2" data-id="element-29">→ FREE</span>
              </div>

              <p className="text-white/80 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-turquoise text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 max-w-3xl mx-auto shadow-xl border border-navy/10" data-id="element-32">
          <h3 className="text-2xl font-serif font-bold text-navy text-center mb-6" data-id="element-33">
            Total value of everything included
          </h3>

          <div className="space-y-2 mb-8 text-sm" data-id="element-34">
            {[['Module 1 — Speaking & Conversation', '$37'], ['Module 2 — Reading & Writing', '$37'], ['Module 3 — Listening & Vocabulary', '$37'], ['Module 4 — Grammar In Context', '$37'], ['Module 5 — Cultural Immersion & Projects', '$37'], ['Module 6 — Assessments & Emergency Lessons', '$37'], ['BONUS 1 — Spanish Conversation Cards Pack', '$27'], ['BONUS 2 — No-Prep Spanish Activities Pack', '$27'], ["BONUS 3 — Spanish Teacher's Emergency Vault", '$37'], ['BONUS 4 — Hispanic Culture Classroom Pack', '$27'], ['BONUS 5 — Spanish Assessments and Rubrics Pack', '$37']].map((item, i) => <div key={i} className="flex justify-between border-b border-navy/5 pb-2 last:border-0" data-id="element-35">
                <span className="text-navy-light" data-id="element-36">{item[0]}</span>
                <span className="font-medium text-navy" data-id="element-37">{item[1]}</span>
              </div>)}
            <div className="flex justify-between pt-4 border-t-2 border-navy/10 font-bold text-lg" data-id="element-38">
              <span className="text-navy" data-id="element-39">TOTAL VALUE</span>
              <span className="text-gold-dark line-through" data-id="element-40">USD 49.90</span>
            </div>
          </div>

          <div className="text-center" data-id="element-41">
            <p className="text-lg text-navy-light mb-2" data-id="element-42">Your price today</p>
            <p className="text-5xl font-bold text-turquoise-gradient mb-4" data-id="element-43">
              $19.90
            </p>
          </div>
        </motion.div>

        <CountdownTimer data-id="element-44" />
      </div>
    </section>;
}